import { ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes';

export const PLAN_SETTINGS_ROUTE_NAMES = new Set<string>([
	ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_AUTO_SCHEDULER,
	ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_CUSTOM_FIELDS,
	ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_EXCLUSION_RULES,
	ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_FIND_YOUR_ISSUE,
	ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_ISSUE_SOURCES,
	ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_PERMISSIONS,
	ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_PLAN_INFO,
	ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_PROGRAM_BOARDS,
	ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_REMOVED_ISSUES,
	ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_SAVED_VIEWS,
	ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_SCENARIOS,
	ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_SCHEDULING,
]);
